"use client";

import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import { hasManagementRights } from "@/helpers/teams";

/**
 * Composant de protection pour les pages réservées aux managers et owners
 * Redirige les membres simples vers la page d'accueil
 */
export function ManagerOnly({ children, locale = "fr" }) {
    const { data: session, status } = useSession();
    const router = useRouter();

    useEffect(() => {
        if (status === "loading") return;

        // Si pas authentifié, rediriger vers login
        if (status === "unauthenticated") {
            router.push(`/${locale}/login`);
            return;
        }

        // Si pas de currentTeam, rediriger vers /teams
        if (!session?.user?.currentTeam) {
            router.push(`/${locale}/teams`);
            return;
        }

        // Si membre simple (pas owner ni manager), rediriger vers la page d'accueil
        if (!hasManagementRights(session)) {
            router.push(`/${locale}`);
            return;
        }
    }, [session, status, router, locale]);

    // Afficher un loader pendant la vérification
    if (
        status === "loading" ||
        !session?.user?.currentTeam ||
        !hasManagementRights(session)
    ) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <SolarIcon name="refresh-linear" className="w-8 h-8 animate-spin text-blue-500" />
            </div>
        );
    }

    // Si owner ou manager, afficher le contenu
    return <>{children}</>;
}
